import { render, staticRenderFns } from "./SRow.vue?vue&type=template&id=1f316772&scoped=true"
import script from "./SRow.vue?vue&type=script&lang=js"
export * from "./SRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f316772",
  null
  
)

export default component.exports